$( document ).ready(function() {
  initApp();
  //click listener square item
  $(".square-item").click(function() {
    var item=$('#'+this.id);
    
    nextClickEvent(item,0);
  });

  $(".selection-item").click(function() {
    var item=$('#'+this.id);
    
    nextClickEvent(item,1);
  });
  
  //click listener next button
  $(".nxt-btn").click(function() {
    var item=$('#'+this.id);

    nextClickEvent(item,0);
  });
  
  //click listener next button
  $(".buy-btn").click(function() {
    buyButtonEvent(this.id);
  });
  
  $(".addonbuy-btn").click(function(){
    addonButtonEvent(this.id);
  });
});


/////////////////cookie functions

//set the cookie
function setCookie(cname, cvalue, exdays=3) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

//get the cookie
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function getOptions(level){
  return o_arr[level];
}


function initApp(){
  let cnav=getCookie('cf-nav');
    if(cnav!=""){
    //nav cookie set
    if(navarr.includes(cnav)){
      setNav(cnav);
    } else {
      setNav(defnav); //set to defaultnav
    }
  } else {
    //no nav cookie set
    setNav(defnav); //set to defaultnav
  }
  
  jQuery.each(navarr,function(i,level){
    if(level=='h-level3'){
      var inputspec='';
      jQuery.each(ops_arr[level],function(i,opval){
      var gc=getCookie(level+'-'+opval);
      
      if(gc=="" || gc==0){
        $('#'+opval).removeClass('related_active');
      } else {
        inputspec = $('#'+opval).data('inputspec');
        $('#'+opval).addClass('related_active');
      }
      gc="";
      });
      $('#inputspec').val(inputspec);
    } else {
      jQuery.each(ops_arr[level],function(i,opval){
      var gc=getCookie(level+'-'+opval);
      if(gc!=""){
        $('#'+opval).val(gc);
      }
      
      gc="";
      });
    }
  });
  set_nieuw();
}

//clicked on an item
function nextClickEvent(item,selector){
  var level=item.data('level');
  var id=item.data('id');
  var nextlevel=item.data('nextlevel');

  setAction(level,nextlevel,id,selector);
}

function setNav(cnav){
   var showArr=[];
  jQuery.each(alsoShow[cnav],function(i,val){
    showArr.push(val);
  });
  
  
  jQuery.each(navarr,function(i,val){
    if(showArr.includes(val)){
      $('#'+val).show("fast");
      
    } else {
      $('#'+val).hide();
    }
  });
  setCookie('cf-nav',cnav);
}

function onchange_update(inp){
  var item=$('#'+inp.id);
  var level=item.data('level');
  var id=inp.id
  var val=item.val();
  updateDataVal(level,id,val);
}

function updateDataVal(level,id,val){
  setCookie(level+'-'+id,val);
}

function setAction(level,nextlevel,id,selector){
  setNav(nextlevel);

  if(selector==1){
    var inputspec='';
    jQuery.each(ops_arr[level],function(i,opval){
      if(opval==id){
        updateDataVal(level,opval,1);
        inputspec=$('#'+opval).data('inputspec');
        $('#'+opval).addClass('related_active');
      } else {
        updateDataVal(level,opval,0);
        $('#'+opval).removeClass('related_active');
      }
    });
    $('#inputspec').val(inputspec);
    set_nieuw();
  } else {
     jQuery.each(ops_arr[level],function(i,opval){
      var dataval = $('#'+opval).val();
      updateDataVal(level,opval,dataval)
    }); 
  }
}

//clicked buy button
function buyButtonEvent(btn){
  /*collect items to add to cart*/
  const quantity=[];
  const item_id=[];
  const c_arr=[];

  $('.product_loop').each(function(i,obj){
    var prod_id=$('#'+obj.id).data('variantid');
    var count=$('#'+obj.id).val();
    if(count>0){
      const c_obj={id:prod_id,quantity:count}
      c_arr.push(c_obj);
    }
  });
  addAllItems(btn,c_arr);  
}

//addon add button event
function addonButtonEvent(btn){
  var variant_id=$('#'+btn).data('id');
  $('#prod-'+variant_id+'-overzicht-aantal-desktop').val("1");
  $('#prod-'+variant_id+'-overzicht-aantal-mobile').val("1");
  $('#h-overzicht-prod-'+variant_id).show();
  $('#'+btn).html('<i class="fas fa-check"></i> Toegevoegd');
  $('#'+btn).prop('disabled', true);
  setCookie('prod-'+variant_id,1);
}

function addAllItems(btn_id,c_arr){
  /*submitButton.setAttribute('aria-disabled', true);
  submitButton.classList.add('loading');
  document.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  document.cartNotification = document.querySelector('cart-notification');
  document.cartNotification.setActiveElement(document.activeElement);
  */
  
  var submitButton=$('#'+btn_id);
  submitButton.attr('disabled', 'disabled');
  document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
              
  
  fetch('/cart/add.js', {
    method: "post",
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
    items: c_arr
    })
  })
  .then((response) => response.json())
  .then((response) => {
    	document.dispatchEvent(new CustomEvent('theme:loading:end'));
    	submitButton.removeAttr('disabled'); // We simply trigger an event so the mini-cart can re-render
    if (response.status) {
      console.error(response.description);
      return;
    }
    /*document.cartNotification.renderMultipleContents(response);*/
    window.location.href = 'https://www.junglescape.nl/cart';
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {
   /* submitButton.classList.remove('loading');
  	submitButton.removeAttribute('aria-disabled');
  	document.querySelector('.loading-overlay__spinner').classList.add('hidden');*/
  });
}